import React, { useRef } from "react";
import {
    Box,
    Typography,
    Chip,
    IconButton,
    Grid,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Variant, VariantImage } from "../../types/Products";

interface Props {
    variants: any[];
    selectedVariant: number;
    setSelectedVariant: (index: number) => void;
}

const VariantSlider = ({
    variants,
    selectedVariant,
    setSelectedVariant,
}: Props) => {
    const sliderRef = useRef<Slider | null>(null);

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <Box
            sx={{
                position: "relative",
                borderRadius: 3,
                p: 2,
                px: 3
                // bgcolor: "#fff",
            }}
        >
            <IconButton
                onClick={() => sliderRef.current?.slickPrev()}
                sx={{
                    position: "absolute",
                    left: -18,
                    top: "50%",
                    transform: "translateY(-50%)",
                    bgcolor: "var(--primary-color)",
                    color: "#fff",
                    boxShadow: 2,
                    zIndex: 10,
                    "&:hover": {
                        bgcolor: "var(--primary-color)",
                        color: "#fff",
                    },
                }}
            >
                <ChevronLeftIcon />
            </IconButton>

            <Slider ref={sliderRef} {...settings}>
                {variants?.map((variant, index) => (
                    <Box key={index} className='px-1'>
                        <Box
                            onClick={() => setSelectedVariant(index)}
                            className='border-10 p-2'
                            sx={{
                                cursor: "pointer",
                                border:
                                    selectedVariant === index
                                        ? "2px solid var(--primary-color)"
                                        : "1px solid #E5E7EB",
                                transition: ".3s",
                                position: "relative",
                                "&:hover": {
                                    borderColor: "var(--primary-color)",
                                },
                            }}
                        >
                            <Box className='d-flex gap-1'>
                                <Grid container spacing={1.5}>
                                    <Grid size={{ xs: 4 }}>
                                        <Box component={'img'} width={'100%'} height={'100%'} sx={{ objectFit: 'center', maxHeight: '49px' }} src={variant?.images?.find((item: VariantImage) => item?.is_thumbnail)?.image_url || variant?.images[0]?.image_url}></Box>
                                    </Grid>
                                    <Grid size={{ xs: 8 }}>
                                        <Typography
                                            className="fw-bold"
                                            noWrap
                                        >
                                            {variant.name}
                                        </Typography>

                                        {/* <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            noWrap
                                        >
                                            SKU: {variant.sku}
                                        </Typography> */}

                                        <Typography
                                            variant="caption"
                                            color="success.main"
                                            className="mt-1"
                                        >
                                            ₹{variant.price}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Slider>

            <IconButton
                onClick={() => sliderRef.current?.slickNext()}
                sx={{
                    position: "absolute",
                    right: -18,
                    top: "50%",
                    transform: "translateY(-50%)",
                    bgcolor: "var(--primary-color)",
                    color: "#fff",
                    "&:hover": {
                        bgcolor: "var(--primary-color)",
                        color: "#fff",
                    },
                    boxShadow: 2,
                    zIndex: 10,
                }}
            >
                <ChevronRightIcon />
            </IconButton>
        </Box>
    );
};

export default VariantSlider;